<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const emit = defineEmits(['import', 'export']);

const { t } = useI18n();
const showActionsDropdown = ref(false);

const menuItems = computed(() => [
  {
    label: t('CANNED_MGMT.ACTIONS.IMPORT'),
    action: 'import',
    value: 'import',
    icon: 'i-lucide-download',
  },
  {
    label: t('CANNED_MGMT.ACTIONS.EXPORT'),
    action: 'export',
    value: 'export',
    icon: 'i-lucide-upload',
  },
]);

const handleAction = ({ action }) => {
  showActionsDropdown.value = false;
  if (action === 'import') emit('import');
  if (action === 'export') emit('export');
};
</script>

<template>
  <div v-on-clickaway="() => (showActionsDropdown = false)" class="relative">
    <Button
      icon="i-lucide-ellipsis-vertical"
      color="slate"
      variant="ghost"
      size="sm"
      :aria-label="t('CANNED_MGMT.ACTIONS.MENU')"
      :class="showActionsDropdown ? 'bg-n-alpha-2' : ''"
      @click="showActionsDropdown = !showActionsDropdown"
    />
    <DropdownMenu
      v-if="showActionsDropdown"
      :menu-items="menuItems"
      class="ltr:right-0 rtl:left-0 mt-1 w-72 top-full"
      @action="handleAction"
    />
  </div>
</template>
